import { ReactNode, RefObject, useEffect, useRef } from 'react';

interface GetNameProps {
  children?: ReactNode;
  callback?: (id: string) => void;
}

const GetName: React.FunctionComponent<GetNameProps> = function ({
  children,
  callback,
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current || !callback) return;
    const id = (ref?.current?.firstChild as HTMLDivElement)?.id?.replace(
      '-wrapper',
      '',
    );
    callback(id);
  }, [callback]);

  if (!children) return null;
  return (
    <div className="w-full" ref={ref as RefObject<HTMLDivElement>}>
      {children}
    </div>
  );
};

export default GetName;
